import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HistoryRouter as Router } from "redux-first-history/rr6";
import { Helmet } from "react-helmet";
import { store, history } from "./store";

import "./index.css";
import App from "./App";
import CognitoProvider from "./cognitoProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <CognitoProvider>
      <Router history={history}>
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        </Helmet>
        <App />
      </Router>
    </CognitoProvider>
  </Provider>
);
